/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { ControlTable } from "../../components/Table";
import { get } from "lodash";
import systemAlert from "../../utils/systemAlert";
import useForm from "../../hooks/useForm";
import { getParams } from "../../utils/params";
import { denieEmployeeRequest, getEmployeeRequest } from "../../apis/employee/employee";
import { getCompanyTokenInfo } from "../../apis/auth";
import { employeeDetailView } from "../../utils/employee";

const EmployeeRequest = ({ permission, isTax = false }) => {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    setFields([
      {
        title: "신청일",
        key: "createdTime",
        type: 'date'
      },
      {
        title: "신청자명",
        key: "user.name"
      },
      {
        title: "신청자 ID",
        key: "user.id"
      },
      {
        title: "신청자 연락처",
        key: "user.mobile"
      },
      {
        isHide: permission.level <= 1,
        type: 'button',
        size: 'x-sm',
        color: 'green',
        label: '등록',
        style: {
          width: '80px'
        },
        onClick: ({ data }) => {
          approveEmployeeReqeust(data);
        }
      },
      {
        isHide: permission.level <= 1,
        type: 'button',
        size: 'x-sm',
        color: 'red',
        label: '반려',
        style: {
          width: '80px'
        },
        onClick: ({ data }) => {
          denieEmployeeReqeust(data);
        }
      },
    ]);
  }, [permission]);

  const denieEmployeeReqeust = ({ user }) => {
    systemAlert(
      `"${user.name}"님의 직원 등록 요청을 반려 하시겠습니까?`,
      {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '반려',
            onClick: () => {
              denieEmployeeRequest(user, isTax)
                .then(() => {
                  handleSubmit();
                });
            }
          }
        ]
      }
    );
  };
  const {
    form,
    setSubmit,
    // handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    // selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  const submit = (params) => {
    const { companyIdx, managerCompanyIdx } = getCompanyTokenInfo();
    getEmployeeRequest(isTax ? managerCompanyIdx : companyIdx, getParams(params))
      .then((res) => {
        setTotal(get(res, "data.count"));
        setList(get(res, "data.requestes"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const approveEmployeeReqeust = ({ user }) => {
    employeeDetailView({
      mode: 'create',
      options: {
        selectedUser: user,
        submit: filterSubmit,
        isTax
      }
    });
  };

  return (
    <>
      <ControlTable
        title={'직원 등록 대기중 목록'}
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        // onSelect={openDetail}
        submit={handleSubmit}
      />
    </>
  );
};

export default EmployeeRequest;
